"use client";

import Picture1 from "../images/top-recommended/dinner-cruise-bangkok.webp";
import Picture2 from "../images/top-recommended/golden-buddha.webp";
import Picture3 from "../images/top-recommended/safarii-world.webp";
import Picture4 from "../images/top-recommended/james-bond-island.webp";
import Picture5 from "../images/top-recommended/simon-cabaret-show.webp";
import Picture6 from "../images/top-recommended/snorkeling.webp";
import Picture7 from "../images/top-recommended/coral-island.webp";
import Picture8 from "../images/top-recommended/tiger-topia.webp";
import Picture9 from "../images/top-recommended/underwater-world-pattaya.webp";
import Picture10 from "../images/top-recommended/wat-arun.webp";
import Picture11 from "../images/top-recommended/phi-phi-island.webp";
import Picture12 from "../images/top-recommended/phuket-carnival-magic.webp";

import PaginationLeft from "@/public/svg/paginarition-arrow-left.svg";
import PaginationRight from "@/public/svg/paginarition-arrow-right.svg";

import Heading from "@/components/heading/heading";

import Image from "next/image";

import "@/styles/common/typo.scss";
import "@/sections/common/top-recommended/top-recommended.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Navigation } from "swiper/modules";

const TopRecommendedList = [
    {
        name: "Dinner Cruise Bangkok",
        picture: Picture1,
        location: "",
    },
    {
        name: "Golden Buddha",
        picture: Picture2,
        location: "",
    },
    {
        name: "Safai World Bangkok",
        picture: Picture3,
        location: "",
    },
    {
        name: "James Bond Island",
        picture: Picture4,
        location: "",
    },
    {
        name: "Simon Cabaret Show",
        picture: Picture5,
        location: "",
    },
    {
        name: "Snorkeling",
        picture: Picture6,
        location: "",
    },
    {
        name: "Coral Island Pattaya",
        picture: Picture7,
        location: "",
    },
    {
        name: "Tiger Topia",
        picture: Picture8,
        location: "",
    },
    {
        name: "Underwater World Pattaya",
        picture: Picture9,
        location: "",
    },
    {
        name: "Wat Arun",
        picture: Picture10,
        location: "",
    },
    {
        name: "Phi Phi Island",
        picture: Picture11,
        location: "",
    },
    {
        name: "Phuket Carnival Magic",
        picture: Picture12,
        location: "",
    },
];

const TopRecommended = () => {
    return (
        <section className="top-recommended-section flex items-center py-10 md:py-20 gap-6">
            <div className="top-recommended-info flex flex-col gap-4 container-start">
                <div className="form-title flex flex-col">
                    <Heading as="h3" className="font-yesteryear font-extralight">
                        Top Recommended
                    </Heading>
                    <Heading as="h2" className="text-white">
                        Must Do Things
                    </Heading>
                </div>
                <p className="lead">
                Uncover diverse cultures, savor local flavors, and wander through stunning landscapes.
                </p>
                <div className="swiper-pagination-wrapper flex items-center gap-2 mt-2">
                    <div className="pagination-arrows flex items-center gap-3 sm:gap-4">
                        <figure className="pagination-left-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationLeft}
                                alt="Pagination Left"
                                
                            />
                        </figure>
                        <figure className="pagination-right-top-recommended flex-center">
                            <Image loading="lazy"
                                src={PaginationRight}
                                alt="Pagination Right"
                                
                            />
                        </figure>
                    </div>
                </div>
            </div>
            <div className="top-recommended-slider pl-4">
                <Swiper
                    spaceBetween={16}
                    slidesPerView={1}
                    navigation={{
                        nextEl: ".pagination-right-top-recommended",
                        prevEl: ".pagination-left-top-recommended",
                        enabled: true,
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        480: {
                            slidesPerView: 2,
                        },
                        767: {
                            slidesPerView: 3,
                        },
                        1023: {
                            slidesPerView: 2,
                        },
                        1279: {
                            slidesPerView: 3,
                        },
                        1535: {
                            slidesPerView: 4,
                        },
                    }}
                    className="top-recommended-swiper"
                >
                    {TopRecommendedList.map((t, index) => {
                        return (
                            <SwiperSlide
                                key={index}
                                className="top-recommended-slide"
                            >
                                <a
                                    
                                    className="inline-flex flex-col gap-6"
                                >
                                    <figure>
                                        <Image loading="lazy"
                                            src={t.picture}
                                            alt={t.name}
                                            
                                        />
                                        <figcaption className="flex flex-col items-start justify-end p-4">
                                            <Heading
                                                as="h6"
                                                className="text-white"
                                            >
                                                {t.name}
                                            </Heading>
                                            <span className="font-light text-white">
                                                {t.location}
                                            </span>
                                        </figcaption>
                                    </figure>
                                </a>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </section>
    );
};

export default TopRecommended;
